const STAGE_PROBABILITY_MAP: Record<string, number> = {
    identified: 0.10,
    engaged: 0.25,
    submitted: 0.40,
    negotiation: 0.75,
}

const STAGE_RANK_MAP: Record<string, number> = {
    negotiation: 1,
    submitted: 2,
    engaged: 3,
    identified: 4,
}

/**
 * Matches stage names flexibly — exact first, then prefix.
 * Handles "Submitted RFQ/MSA", "Submitted Proposal" → both map to "submitted" (40%).
 */
export const getStageProbability = (stageName: string): number => {
    if (!stageName) return 0
    const normalized = stageName.toLowerCase().trim()
    if (STAGE_PROBABILITY_MAP[normalized] !== undefined) return STAGE_PROBABILITY_MAP[normalized]
    for (const [key, prob] of Object.entries(STAGE_PROBABILITY_MAP)) {
        if (normalized.startsWith(key)) return prob
    }
    return 0
}

export const getStageRank = (stageName?: string): number => {
    if (!stageName) return 999
    const normalized = stageName.toLowerCase().trim()
    for (const key of Object.keys(STAGE_RANK_MAP)) {
        if (normalized.startsWith(key)) return STAGE_RANK_MAP[key]
    }
    return 999
}